<ngx-profile
	*ngIf="!!selectedUser"
	[selectedUser]="selectedUser"
	[allowRoleChange]="true"
	(userSubmitted)="goBack()"
></ngx-profile>
